module.exports = "<p>\n  transport-management works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/component/pricing-booking/transport-management/transport-management.component.html
// module id = ./src/app/component/pricing-booking/transport-management/transport-management.component.html
// module chunks = main